var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 472;
var h = 472;
var nm = "transfer 45 noout";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "down arrw head",
        parent: 3,
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: -135,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    148.769,
                    -0.771,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    -23,
                    24.5,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        23.605,
                                        23.608
                                    ],
                                    [
                                        -23.605,
                                        23.607
                                    ],
                                    [
                                        -23.605,
                                        -23.608
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960785687,
                                0.639215707779,
                                1,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 21.905,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 8,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 14.0000005702317,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 8,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 14.0000005702317,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 3,
        nm: "Trace down body: Path 1 [1.1]",
        cl: "1",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10,
                x: "var $bm_rt;\nvar pathToTrace = thisComp.layer('down body')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"
            },
            p: {
                a: 0,
                k: [
                    144.5,
                    330.5,
                    0
                ],
                ix: 2,
                l: 2,
                x: "var $bm_rt;\nvar pathLayer = thisComp.layer('down body');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"
            },
            a: {
                a: 0,
                k: [
                    132.936,
                    -0.719,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ef: [
            {
                ty: 5,
                nm: "Trace Path",
                np: 4,
                mn: "Pseudo/ADBE Trace Path",
                ix: 1,
                en: 1,
                ef: [
                    {
                        ty: 0,
                        nm: "Progress",
                        mn: "Pseudo/ADBE Trace Path-0001",
                        ix: 1,
                        v: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.833
                                        ],
                                        y: [
                                            0.833
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.333
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 0,
                                    s: [
                                        0
                                    ]
                                },
                                {
                                    t: 14.0000005702317,
                                    s: [
                                        100
                                    ]
                                }
                            ],
                            ix: 1,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('down body').content('Trim Paths 1').end;"
                        }
                    },
                    {
                        ty: 7,
                        nm: "Loop",
                        mn: "Pseudo/ADBE Trace Path-0002",
                        ix: 2,
                        v: {
                            a: 0,
                            k: 1,
                            ix: 2
                        }
                    }
                ]
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "down body",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    281.588,
                    279.133,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.025
                            ]
                        ],
                        o: [
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.025
                            ],
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ]
                        ],
                        v: [
                            [
                                -47.501,
                                -273.499
                            ],
                            [
                                182.5,
                                -43.5
                            ],
                            [
                                -47.499,
                                186.499
                            ],
                            [
                                -277.5,
                                -43.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 8,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    213.682,
                                                    -212.961
                                                ],
                                                [
                                                    -52.322,
                                                    52.322
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 14.0000005702317,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    52.322,
                                                    -52.322
                                                ],
                                                [
                                                    -52.322,
                                                    52.322
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960785687,
                                0.639215707779,
                                1,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 21.905,
                            ix: 5
                        },
                        lc: 2,
                        lj: 1,
                        ml: 10,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 0,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 14.0000005702317,
                            s: [
                                95
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "up head",
        parent: 6,
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 45,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    92.907,
                    -0.064,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -23.605,
                                        -23.608
                                    ],
                                    [
                                        23.605,
                                        -23.607
                                    ],
                                    [
                                        23.605,
                                        23.608
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960785687,
                                0.639215707779,
                                1,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 21.905,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 8,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 14.0000005702317,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 8,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 14.0000005702317,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 6,
        ty: 3,
        nm: "Trace up body: Path 1 [1.1]",
        cl: "1",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10,
                x: "var $bm_rt;\nvar pathToTrace = thisComp.layer('up body')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"
            },
            p: {
                a: 0,
                k: [
                    313.5,
                    160,
                    0
                ],
                ix: 2,
                l: 2,
                x: "var $bm_rt;\nvar pathLayer = thisComp.layer('up body');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"
            },
            a: {
                a: 0,
                k: [
                    107.126,
                    -0.36,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ef: [
            {
                ty: 5,
                nm: "Trace Path",
                np: 4,
                mn: "Pseudo/ADBE Trace Path",
                ix: 1,
                en: 1,
                ef: [
                    {
                        ty: 0,
                        nm: "Progress",
                        mn: "Pseudo/ADBE Trace Path-0001",
                        ix: 1,
                        v: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.833
                                        ],
                                        y: [
                                            0.833
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.333
                                        ],
                                        y: [
                                            0
                                        ]
                                    },
                                    t: 0,
                                    s: [
                                        0
                                    ]
                                },
                                {
                                    t: 14.0000005702317,
                                    s: [
                                        100
                                    ]
                                }
                            ],
                            ix: 1,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('up body').content('Trim Paths 1').end;"
                        }
                    },
                    {
                        ty: 7,
                        nm: "Loop",
                        mn: "Pseudo/ADBE Trace Path-0002",
                        ix: 2,
                        v: {
                            a: 0,
                            k: 1,
                            ix: 2
                        }
                    }
                ]
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "up body",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    214.553,
                    192.914,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.025
                            ]
                        ],
                        o: [
                            [
                                127.026,
                                0
                            ],
                            [
                                0,
                                127.025
                            ],
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ]
                        ],
                        v: [
                            [
                                20.499,
                                -185.499
                            ],
                            [
                                250.5,
                                44.5
                            ],
                            [
                                20.501,
                                274.499
                            ],
                            [
                                -209.5,
                                44.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 8,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -209.588,
                                                    209.056
                                                ],
                                                [
                                                    52.322,
                                                    -52.322
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 14.0000005702317,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -52.322,
                                                    52.322
                                                ],
                                                [
                                                    52.322,
                                                    -52.322
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960785687,
                                0.639215707779,
                                1,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 21.905,
                            ix: 5
                        },
                        lc: 2,
                        lj: 1,
                        ml: 10,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 0,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 14.0000005702317,
                            s: [
                                95
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: "fill",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    238,
                    236,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    1000,
                    1000,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                ty: "gr",
                                it: [
                                    {
                                        ty: "gr",
                                        it: [
                                            {
                                                ind: 0,
                                                ty: "sh",
                                                ix: 1,
                                                ks: {
                                                    a: 0,
                                                    k: {
                                                        i: [
                                                            [
                                                                -127.025,
                                                                0
                                                            ],
                                                            [
                                                                0,
                                                                -127.025
                                                            ],
                                                            [
                                                                127.026,
                                                                0
                                                            ],
                                                            [
                                                                0,
                                                                127.025
                                                            ]
                                                        ],
                                                        o: [
                                                            [
                                                                127.025,
                                                                0
                                                            ],
                                                            [
                                                                0,
                                                                127.025
                                                            ],
                                                            [
                                                                -127.025,
                                                                0
                                                            ],
                                                            [
                                                                0,
                                                                -127.025
                                                            ]
                                                        ],
                                                        v: [
                                                            [
                                                                -0.001,
                                                                -229.999
                                                            ],
                                                            [
                                                                230,
                                                                0
                                                            ],
                                                            [
                                                                0.001,
                                                                229.999
                                                            ],
                                                            [
                                                                -230,
                                                                0
                                                            ]
                                                        ],
                                                        c: true
                                                    },
                                                    ix: 2
                                                },
                                                nm: "Path 1",
                                                mn: "ADBE Vector Shape - Group",
                                                hd: false
                                            },
                                            {
                                                ty: "fl",
                                                c: {
                                                    a: 0,
                                                    k: [
                                                        0.945098042488,
                                                        0.972549021244,
                                                        1,
                                                        1
                                                    ],
                                                    ix: 4,
                                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                                                },
                                                o: {
                                                    a: 0,
                                                    k: 100,
                                                    ix: 5
                                                },
                                                r: 1,
                                                bm: 0,
                                                nm: "Fill 1",
                                                mn: "ADBE Vector Graphic - Fill",
                                                hd: false
                                            },
                                            {
                                                ty: "tr",
                                                p: {
                                                    a: 0,
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    ix: 2
                                                },
                                                a: {
                                                    a: 0,
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    ix: 1
                                                },
                                                s: {
                                                    a: 0,
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    ix: 3
                                                },
                                                r: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 6
                                                },
                                                o: {
                                                    a: 0,
                                                    k: 100,
                                                    ix: 7
                                                },
                                                sk: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 4
                                                },
                                                sa: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 5
                                                },
                                                nm: "Transform"
                                            }
                                        ],
                                        nm: "Oval",
                                        np: 2,
                                        cix: 2,
                                        bm: 0,
                                        ix: 1,
                                        mn: "ADBE Vector Group",
                                        hd: false
                                    },
                                    {
                                        ty: "tr",
                                        p: {
                                            a: 0,
                                            k: [
                                                500,
                                                500
                                            ],
                                            ix: 2
                                        },
                                        a: {
                                            a: 0,
                                            k: [
                                                0,
                                                0
                                            ],
                                            ix: 1
                                        },
                                        s: {
                                            a: 0,
                                            k: [
                                                100,
                                                100
                                            ],
                                            ix: 3
                                        },
                                        r: {
                                            a: 0,
                                            k: 0,
                                            ix: 6
                                        },
                                        o: {
                                            a: 0,
                                            k: 100,
                                            ix: 7
                                        },
                                        sk: {
                                            a: 0,
                                            k: 0,
                                            ix: 4
                                        },
                                        sa: {
                                            a: 0,
                                            k: 0,
                                            ix: 5
                                        },
                                        nm: "Transform"
                                    }
                                ],
                                nm: "icon/2tone/transaction-copy",
                                np: 1,
                                cix: 2,
                                bm: 0,
                                ix: 1,
                                mn: "ADBE Vector Group",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        500,
                                        500
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "nav-v2-transactions",
                        np: 1,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                500,
                                500
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                500,
                                500
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "symbols",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var Transfer45 = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Transfer45 as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Transfer45.json.es.js.map
